const baseURL = 'https://catalogo.colmenafusion.com.ar/';

export default baseURL;
